import { render, staticRenderFns } from "./FactorTable.vue?vue&type=template&id=196e8979&scoped=true"
import script from "./FactorTable.vue?vue&type=script&lang=js"
export * from "./FactorTable.vue?vue&type=script&lang=js"
import style0 from "./FactorTable.vue?vue&type=style&index=0&id=196e8979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e8979",
  null
  
)

export default component.exports